export const KM_IN_MILE = 1.609344;
export const FUEL_PRODUCT_CODES = ["E5", "E10", "B7", "SDV"];
export const RANGES_FOR_PRODUCT_SEARCH = [5, 7, 10, 15, 25, 50, 100]; // in miles
export const STORE_INTEGRATION_TYPE = {
  LIVE_PRICE: "LIVE_PRICE",
};

export const PRICE_HISTORY_LIMIT = 5;
